import React from "react";
import logoCcb from "../../assets/cez/alianzas/ccb.png";
import logoAneia from "../../assets/cez/alianzas/aneia.png";

export const cezAlianzas = [
  {
    id: "ccb",
    nombre: "Cámara de Comercio de Bogotá",
    logo: logoCcb,
  },
  {
    id: "aneia",
    nombre: "ANeIA · Universidad de los Andes",
    logo: logoAneia,
  },
];

function CezAlianzasSection({ title, intro }) {
  return (
    <section className="py-16 px-6 sm:px-10 lg:px-16 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0b1f3f]">{title}</h2>
          {intro && <p className="mt-4 text-slate-600 text-lg leading-relaxed">{intro}</p>}
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-2 sm:px-6">
          {cezAlianzas.map((alianza) => (
            <article
              key={alianza.id}
              className="flex h-44 sm:h-48 flex-col items-center justify-center rounded-3xl border border-slate-200 bg-white px-6 py-5 shadow-sm"
            >
              <img
                src={alianza.logo}
                alt={alianza.nombre}
                className="max-h-28 w-full object-contain"
              />
              <p className="mt-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-600">
                {alianza.nombre}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CezAlianzasSection;
